export default __webpack_public_path__ + "assets/images/9404d875fbcab6f95ce43839dc5b2685.png";